import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  RawDraftContentState,
  ApiManagersBusinessSectionsBusinessSectionMemoReviewsMutateResponseType,
  PreviewWithFileType,
} from "~/domains";

type RequestDataType = {
  businessSectionId: string;
  body: {
    content: RawDraftContentState;
    attachFiles: PreviewWithFileType[];
  };
};

const request = ({ businessSectionId, body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ businessSectionMemoReview: body });
  return new ApiClient()
    .post<ApiManagersBusinessSectionsBusinessSectionMemoReviewsMutateResponseType>(
      `/api/managers/business_sections/${businessSectionId}/business_section_memo_reviews`,
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersBusinessSectionsBusinessSectionMemoReviewsCreate =
  ({ options = {} }: PropsType = {}): UseMutationResult<
    ApiManagersBusinessSectionsBusinessSectionMemoReviewsMutateResponseType,
    RequestDataType
  > => {
    return useMutation(request, { ...options });
  };
